import React, { useState, useCallback, useEffect } from 'react';
import type { ReactNode, FC } from 'react';
import { isType } from 'variant';
import { Text } from '../Text.js';
import { InputState } from '../../input-state.js';
import { InputLabel } from '../InputLabel.js';
import { Placeholder } from './Placeholder.js';
import { Input } from './Input.js';

export interface ConfirmInputProps {
  label: string;
  info?: string | ReactNode;
  initialValue?: boolean;
  isActive?: boolean;
  onSubmit: (value: boolean) => void;
}

export const ConfirmInput: FC<ConfirmInputProps> = ({
  label,
  info,
  initialValue = true,
  isActive,
  onSubmit,
}) => {
  const [inputState, setInputState] = useState<InputState<boolean>>(() =>
    InputState.NotSubmitted(initialValue)
  );

  const handleSubmit = useCallback(
    (value: boolean) => {
      setInputState(InputState.Submitted(value));
      onSubmit(value);
    },
    [onSubmit]
  );

  useEffect(() => {
    if (isActive) {
      setInputState(InputState.NotSubmitted(inputState.value));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive]);

  return (
    <Text>
      <InputLabel>{label}</InputLabel>{' '}
      {info && isType(inputState, InputState.NotSubmitted) && (
        <Text skin="secondary">{info} </Text>
      )}
      <Placeholder inputState={inputState} />
      {isType(inputState, InputState.NotSubmitted) && (
        <Input initialValue={initialValue} onSubmit={handleSubmit} />
      )}
    </Text>
  );
};
